module.exports = {
  siteUrl: process.env.SITE_URL,
  siteName: 'Headlinker',
  linkedin: 'https://www.linkedin.com/company/96305860/admin/feed/posts/',
  youtubeChannelUrl: 'https://www.youtube.com/@headlinker',
  slackUrl: 'https://join.slack.com/t/headlinker/shared_invite/zt-2irlnc1xi-8lfO31KvQQMm_HhldzPRVw',
  whatsapp: 'https://chat.whatsapp.com/Idmc78yFoUlB4UkYE1WQ4d',
  whatsappMartin: 'https://wa.me/+33662478230',
  whatsappDorothee: 'https://wa.me/+33632791518',
  linkedinDorothee: 'https://www.linkedin.com/in/dorothee-de-calan',
  linkedinMartin: 'https://www.linkedin.com/in/martinratinaud',
  calendarUrl: 'https://calendly.com/decalan-dorothee/echange-headlinker',
  email: 'hello@headlinker.com',
  emailHello: 'hello@headlinker.com',
  googleReviewUrl: 'https://g.page/r/CQ7DcjiD63o1EBM/review',
  twitterHandle: 'martinratinaud',
  bucketsMapping: {
    [`${process.env.R2_ENDPOINT}/${process.env.R2_BUCKET}`]: process.env.R2_PUBLIC_URL,
  },
  membershipFeePaymentLink: `${process.env.SITE_URL}/join/membership`,
  availableProfileExpirationDays: 180,
  searchedProfileExpirationDays: 30,
  commissionRate: 0.1,
  endStarter150Date: new Date('2025-06-30 23:59:59'),
  endStarter239Date: new Date('2025-09-30 23:59:59'),
  emailAdmin:
    process.env.NODE_ENV === 'production'
      ? 'lagarde.dorothee+headlinker-dorothee@gmail.com;martin@headlinker.com;enzo@headlinker.com'
      : 'martin@headlinker.com',
  answerDelays: {
    // in hours
    proposed: 24 * 1,
    discovered: 3,
    accepted: 24 * 2,
    inProcess: 24 * 7,
    underOffer: 24 * 7,
    offerAccepted: 24 * 30 * 3,
    trainingStarted: 24 * 30 * 3,
    trainingConfirmed: 24 * 30 * 3,
  },
};
